module.exports = __webpack_public_path__ + "static/media/buysellicon.4f1d17bc.svg";